import Auth0Lock from "auth0-lock";

export function showAuthOnDemand(node, opts) {
  const lock = new Auth0Lock(opts.clientId, opts.domain, {
    container: node.id,
    language: "fr",
    allowLogin: opts.espaceClientIsOpen,
    allowAutocomplete: false,
    allowShowPassword: true,
    allowForgotPassword: opts.espaceClientIsOpen,
    avatar: false,
    allowSignUp: false,
    rememberLastLogin: false,
    allowedConnections: ["ALTIMA-CLIENTS"],
    languageDictionary: {
      title: "Espace client",
      forgotPasswordAction: "Changement de mot de passe ou mot de passe oublié ?",
      unrecoverableError:
        "L'espace client est en maintenance, merci de réessayer utltérieurement"
    },
    theme: {
      logo: `${window.location.origin}/particuliers/auto/assurance-auto-usage/espace-client/assets/images/logo_altima.png`,
      primaryColor: "#FFBA00"
    },
    auth: {
      audience: opts.audience,
      redirectUrl: opts.callback,
      responseType: "code",
      params: {
        scope: "openid email"
      }
    }
  });

  lock.show();
}
